import { render, staticRenderFns } from "./DetailProjectPurchasing.vue?vue&type=template&id=7b27576e&scoped=true"
import script from "./DetailProjectPurchasing.vue?vue&type=script&lang=js"
export * from "./DetailProjectPurchasing.vue?vue&type=script&lang=js"
import style0 from "./DetailProjectPurchasing.vue?vue&type=style&index=0&id=7b27576e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27576e",
  null
  
)

export default component.exports